import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

// Containers
import Container from './../components/Container'
import SectionsList from './../components/SectionsList'
import Section from './../components/Section'
import Error from './../components/Error'

export default new VueRouter({
    mode: 'hash', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'open is-active',
    scrollBehavior: () => ({y: 0}),
    routes: [
        {
            path: '/',
            // redirect: '/sections',
            name: 'Home',
            component: Container,
            children: [
                {
                    path: 'sections',
                    name: 'Sections',
                    component: SectionsList
                },
                {
                    path: 'sections/:section_id',
                    name: 'Section',
                    component: Section
                },
            ]
        },
        {
            path: '/error',
            name: 'Error',
            component: Error
        },
        // ToDo: проверить страницу ошибки
        // {
        //     path: '*',
        //     component: () => Error,
        //     children: [
        //         {
        //             path: 'error',
        //             name: 'Error',
        //             component: () => Error,
        //         },
        //     ]
        // },
    ]
})
